// Organization Reducer
import {
  GET_ORGANIZATIONS,
  GET_ORGANIZATIONS_SUCCESS,
  GET_ORGANIZATIONS_FAIL,
  GET_ORGANIZATIONS_RESET,
  GET_ORGANIZATION_BY_ID,
  GET_ORGANIZATION_BY_ID_SUCCESS,
  GET_ORGANIZATION_BY_ID_FAIL,
  GET_ORGANIZATION_BY_ID_RESET,
  CREATE_ORGANIZATION,
  CREATE_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_FAIL,
  CREATE_ORGANIZATION_RESET,
  UPDATE_ORGANIZATION,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_FAIL,
  UPDATE_ORGANIZATION_RESET,
  DELETE_ORGANIZATION,
  DELETE_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_FAIL,
  DELETE_ORGANIZATION_RESET,
  GET_ORGANIZATIONS_DROPDOWN,
  GET_ORGANIZATIONS_DROPDOWN_SUCCESS,
  GET_ORGANIZATIONS_DROPDOWN_FAIL,
  GET_ORGANIZATIONS_DROPDOWN_RESET,
} from '../actions/organizationAction';

const initialState = {
  getOrganizationsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getOrganizationByIdState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  createOrganizationState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateOrganizationState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  deleteOrganizationState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getOrganizationsDropdownState: {
    apiState: 'idle',
    data: [],
    message: null,
    errors: null,
    error: null,
  },
};

const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORGANIZATIONS:
      return {
        ...state,
        getOrganizationsState: { ...state.getOrganizationsState, apiState: 'loading' },
      };
    case GET_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        getOrganizationsState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Organizations retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_ORGANIZATIONS_FAIL:
      return {
        ...state,
        getOrganizationsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch organizations',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ORGANIZATIONS_RESET:
      return {
        ...state,
        getOrganizationsState: initialState.getOrganizationsState,
      };

    case GET_ORGANIZATION_BY_ID:
      return {
        ...state,
        getOrganizationByIdState: { ...state.getOrganizationByIdState, apiState: 'loading' },
      };
    case GET_ORGANIZATION_BY_ID_SUCCESS:
      return {
        ...state,
        getOrganizationByIdState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Organization retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_ORGANIZATION_BY_ID_FAIL:
      return {
        ...state,
        getOrganizationByIdState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch organization',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ORGANIZATION_BY_ID_RESET:
      return {
        ...state,
        getOrganizationByIdState: initialState.getOrganizationByIdState,
      };

    case CREATE_ORGANIZATION:
      return {
        ...state,
        createOrganizationState: { ...state.createOrganizationState, apiState: 'loading' },
      };
    case CREATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        createOrganizationState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Organization created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_ORGANIZATION_FAIL:
      return {
        ...state,
        createOrganizationState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create organization',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_ORGANIZATION_RESET:
      return {
        ...state,
        createOrganizationState: initialState.createOrganizationState,
      };

    case UPDATE_ORGANIZATION:
      return {
        ...state,
        updateOrganizationState: { ...state.updateOrganizationState, apiState: 'loading' },
      };
    case UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        updateOrganizationState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Organization updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_ORGANIZATION_FAIL:
      return {
        ...state,
        updateOrganizationState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update organization',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_ORGANIZATION_RESET:
      return {
        ...state,
        updateOrganizationState: initialState.updateOrganizationState,
      };

    case DELETE_ORGANIZATION:
      return {
        ...state,
        deleteOrganizationState: { ...state.deleteOrganizationState, apiState: 'loading' },
      };
    case DELETE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        deleteOrganizationState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Organization deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_ORGANIZATION_FAIL:
      return {
        ...state,
        deleteOrganizationState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete organization',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_ORGANIZATION_RESET:
      return {
        ...state,
        deleteOrganizationState: initialState.deleteOrganizationState,
      };

    case GET_ORGANIZATIONS_DROPDOWN:
      return {
        ...state,
        getOrganizationsDropdownState: { ...state.getOrganizationsDropdownState, apiState: 'loading' },
      };
    case GET_ORGANIZATIONS_DROPDOWN_SUCCESS:
      return {
        ...state,
        getOrganizationsDropdownState: {
          apiState: 'success',
          data: action.response.data || action.response || [],
          message: action.response.message || 'Organizations retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_ORGANIZATIONS_DROPDOWN_FAIL:
      return {
        ...state,
        getOrganizationsDropdownState: {
          apiState: 'error',
          data: [],
          message: action.response?.message || action.response || 'Failed to fetch organizations',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ORGANIZATIONS_DROPDOWN_RESET:
      return {
        ...state,
        getOrganizationsDropdownState: initialState.getOrganizationsDropdownState,
      };

    default:
      return state;
  }
};

export default organizationReducer;

